import { useState } from 'react';
import axiosInstance from '../Services/Api';

const ModalCoproducion = ({ setCoproducionModalOpen,getCoproducion, productId }) => {
    const [formData, setFormData] = useState({
        productId: productId,
        email: '',
        name: '',
        comission: '',
        validate: '',
        parcelas: 1,
        affiliateOn: false,
        productorOn: false
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const validateForm = () => {
        if (!formData.validate) {
            setError('Selecione uma data de validade');
            return false;
        }
        if (!formData.email || !formData.name || !formData.comission) {
            setError('Por favor, preencha todos os campos obrigatórios');
            return false;
        }
        if (isNaN(formData.comission) || formData.comission <= 0) {
            setError('Comissão inválida');
            return false;
        }
        return true;
    };

    const handleSubmit = async () => {
        if (!validateForm()) return;

        setLoading(true);
        setError('');

        try {
            // Convert date from yyyy-mm-dd to dd/mm/yyyy
            const [year, month, day] = formData.validate.split('-');
            const formattedDate = `${day}/${month}/${year}`;

            const payload = {
                ...formData,
                comission: parseFloat(formData.comission),
                parcelas: Number(formData.parcelas),
                validate: formattedDate
            };

            const response = await axiosInstance.post('/checkout/createCoProduction', payload);

            if (response.data.success) {
                setCoproducionModalOpen(false);
                getCoproducion(productId)
                // Optional: Add success notification or reset form
            }
        } catch (error) {
            console.error('Error creating coproduction:', error);
            setError(error.response?.data?.message || 'Erro ao criar coprodução');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-[99999] flex items-center justify-center ">
            <div className="bg-[#1D1D1D] rounded-lg shadow-lg md:min-w-[600px]  w-[80%] md:w-full max-w-md p-6 px-0">
                <h2 className="px-4 text-[18px]  font-bold mb-2">Preencha as informações do seu co-produtor</h2>
                <div className="w-full border border-[gray]"></div>

                <div className="px-4 mt-4">
                    {error && <div className="text-red-500 text-sm mb-4">{error}</div>}

                    <div className="flex gap-4 w-full">
                        <div className="flex w-full flex-col">
                            <label className="text-[12px] text-[#AEB9E1] my-1">E-mail do coprodutor</label>
                            <input
                                name="email"
                                type="email"
                                className="bg-[#313131] rounded-[8px] p-1 px-2"
                                value={formData.email}
                                onChange={handleInputChange}
                            />
                        </div>
                    </div>

                    <div className="flex gap-4 w-full mt-4">
                        <div className="flex w-full flex-col">
                            <label className="text-[12px] text-[#AEB9E1] my-1">Nome da Coprodução</label>
                            <input
                                name="name"
                                className="bg-[#313131] rounded-[8px] p-1 px-2"
                                value={formData.name}
                                onChange={handleInputChange}
                            />
                        </div>
                        <div className="flex w-full flex-col">
                            <label className="text-[12px] text-[#AEB9E1] my-1">Data de Validade</label>
                            <input
                                name="validate"
                                type="date"
                                className="bg-[#313131] rounded-[8px] p-1 px-2"
                                value={formData.validate}
                                onChange={handleInputChange}
                                min={new Date().toISOString().split('T')[0]}
                            />
                        </div>
                    </div>

                    <div className="flex gap-4 w-full mt-4">
                        <div className="flex w-full flex-col">
                            <label className="text-[12px] text-[#AEB9E1] my-1">Parcelas</label>
                            <input
                                name="parcelas"
                                type="number"
                                min="1"
                                className="bg-[#313131] rounded-[8px] p-1 px-2"
                                value={formData.parcelas}
                                onChange={handleInputChange}
                            />
                        </div>
                        <div className="flex w-full flex-col">
                            <label className="text-[12px] text-[#AEB9E1] my-1">Comissão (R$)</label>
                            <input
                                name="comission"
                                type="number"
                                step="0.01"
                                className="bg-[#313131] rounded-[8px] p-1 px-2"
                                value={formData.comission}
                                onChange={handleInputChange}
                                min="0"
                                placeholder="0,00"
                            />
                        </div>
                    </div>

                    <h2 className="mt-4 text-[12px] text-[#AEB9E1]">Deve receber comissão de que vendas?</h2>
                    <div className="flex gap-[40px] mt-2">
                        <div className="flex gap-1 items-center">
                            <input
                                type="checkbox"
                                name="productorOn"
                                className="mr-2 rounded-full appearance-none w-5 h-5 bg-[#313131] checked:bg-[#478DF8] checked:border-gray-500"
                                checked={formData.productorOn}
                                onChange={handleInputChange}
                            />
                            <label className="text-[12px]">Vendas do produtor</label>
                        </div>
                        <div className="flex gap-1 items-center">
                            <input
                                type="checkbox"
                                name="affiliateOn"
                                className="mr-2 rounded-full appearance-none w-5 h-5 bg-[#313131] checked:bg-[#478DF8] checked:border-gray-500"
                                checked={formData.affiliateOn}
                                onChange={handleInputChange}
                            />
                            <label className="text-[12px]">Vendas de afiliados</label>
                        </div>
                    </div>
                </div>

                <div className="flex flex-col gap-1 mt-4 px-4">
                    <button
                        className={`px-4 py-2 bg-[#478DF8] text-white rounded-[8px] ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
                        onClick={handleSubmit}
                        disabled={loading}
                    >
                        {loading ? 'Enviando...' : 'Confirmar'}
                    </button>
                    <button
                        onClick={() => setCoproducionModalOpen(false)}
                        className="px-4 py-2 text-white text-[12px] underline rounded"
                    >
                        Cancelar
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ModalCoproducion;
